export const TAG_DICTIONARY = {
  // Paciente Data
  'paciente_nomeCompleto': 'patient.fullName',
  'patient_fullName': 'patient.fullName',
  'paciente_nombreCompleto': 'patient.fullName',

  'paciente_dataNascimento': 'patient.birthday',
  'patient_dob': 'patient.birthday',
  'paciente_fechaNacimiento': 'patient.birthday',

  'paciente_prontuario': 'patient.mrn',
  'patient_mrn': 'patient.mrn',
  'paciente_informeMedico': 'patient.mrn',

  'paciente_cns': 'patient.document0',
  'patient_document1': 'patient.document0',
  'paciente_registroNacionalLaSalud': 'patient.document0',

  'paciente_rg': 'patient.document1',
  'patient_ssn': 'patient.document1',
  'paciente_documentoIdentidad': 'patient.document1',

  'paciente_cpf': 'patient.document2',
  'patient_document2': 'patient.document2',
  'paciente_documento3': 'patient.document2',

  'paciente_certidaoNascimento': 'patient.document3',
  'patient_document3': 'patient.document3',
  'paciente_certificadoNacimiento': 'patient.document3',

  'paciente_outroDocumento': 'patient.document4',
  'patient_document4': 'patient.document4',
  'paciente_otroDocumento': 'patient.document4',

  'paciente_nomeMae': 'patient.mothersName',
  'patient_mothersName': 'patient.mothersName',
  'paciente_nombreMadre': 'patient.mothersName',

  'paciente_telefone1': 'patient.telephone1',
  'patient_phone1': 'patient.telephone1',
  'paciente_telefono1': 'patient.telephone1',

  'paciente_telefone2': 'patient.telephone2',
  'patient_phone2': 'patient.telephone2',
  'paciente_telefono2': 'patient.telephone2',

  'paciente_email': 'patient.email',
  'patient_email': 'patient.email',
  'paciente_correoElectronico': 'patient.email',

  'paciente_endereco': 'patient.address',
  'patient_address': 'patient.address',
  'paciente_direccion': 'patient.address',

  // Clinic Data
  'clinica_nome': 'clinic.name',
  'clinic_name': 'clinic.name',
  'clinica_nombre': 'clinic.name',

  'clinica_endereco': 'clinic.address',
  'clinic_address': 'clinic.address',
  'clinica_direccion': 'clinic.address',

  'clinica_telefone1': 'clinic.telephone1',
  'clinic_phone1': 'clinic.telephone1',
  'clinica_telefono1': 'clinic.telephone1',

  'clinica_telefone2': 'clinic.telephone2',
  'clinic_phone2': 'clinic.telephone2',
  'clinica_telefono2': 'clinic.telephone2',

  'clinica_email': 'clinic.email',
  'clinic_email': 'clinic.email',
  'clinica_correoElectronico': 'clinic.email',
  
  // Exam Data
  'exame_data': 'exam.date',
  'exam_date': 'exam.date',
  'examen_fecha': 'exam.date',

  'exame_observacoes': 'exam.observation',
  'exam_observations': 'exam.observation',
  'examen_observaciones': 'exam.observation'
};